export default function XML_Syllabus() {
  return (
    <div>
      <h1>XML_Syllabus</h1>
      <p>This is the XML_Syllabus component.</p>
    </div>
  );
}